import type { FC, PropsWithChildren, ReactElement } from "react";
import React from "react";
import type { LoginResponse } from "@greatsumini/react-facebook-login";
import FacebookSocialSignIn from "@greatsumini/react-facebook-login";
import { remoteLogger } from "@/utils/remoteLogger";
import { Button } from "@/components/button/Button";

const PROVIDER_NAME = "Facebook";

export type FacebookAuthResponse = Exclude<
  LoginResponse["authResponse"],
  undefined
>;

interface FacebookLoginProps {
  children: ReactElement | Array<ReactElement> | string;
  className?: string;
  onSuccess: (response: FacebookAuthResponse) => void;
  onFailure?: (provider: string, error: unknown) => void;
  onClick?: () => void;
}

const FACEBOOK_APP_ID = "279290055543413";

const FacebookLogin: FC<PropsWithChildren<FacebookLoginProps>> = ({
  children,
  className,
  onSuccess,
  onFailure,
  onClick,
}): ReactElement | null => {
  const handleFailure = (err: unknown) => {
    onFailure?.(PROVIDER_NAME, err);
  };

  return (
    <FacebookSocialSignIn
      appId={FACEBOOK_APP_ID}
      render={(props) => (
        <Button
          className={className}
          onClick={() => {
            onClick?.();
            props.onClick?.();
          }}
        >
          {children}
        </Button>
      )}
      onSuccess={(v) => {
        //In case it is undefined we do want to log it
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (v === undefined) {
          remoteLogger.error(
            "FacebookAuthResponse was expected, got undefined",
          );

          return;
        }
        onSuccess(v);
      }}
      onFail={handleFailure}
    />
  );
};

export { FacebookLogin };
